export type Service = {
  title: string;
  paragraph: string;
  image: string;
  url: string;
  icon?: `icon:${string}`;
};

export const services: Service[] = [
  {
    title: 'Fitness centrum',
    paragraph:
      'Moderně vybavené fitness centrum pro silový i kondiční trénink. Ideální pro začátečníky i pokročilé.',
    image: '/images/fitness/index.webp',
    url: '/fitness-centrum',
    icon: 'icon:fitcenter',
  },
  {
    title: 'Lezecké stěny',
    paragraph:
      'Zasloužený relax po tréninku. Sauna, vířivka a profesionální masáže pro vaši regeneraci.',
    image: '/images/steny/index.webp',
    url: '/lezecke-steny',
    icon: 'icon:climber',
  },
  {
    title: 'Multifunkční sál',
    paragraph:
      'Zlepšete svou fyzičku i disciplínu v našem ringu pod vedením zkušených trenérů.',
    image: '/images/sal/index.webp',
    url: '/multifunkcni-sal',
    icon: 'icon:multihall',
  },
];
